import { render, staticRenderFns } from "./english-test-question.vue?vue&type=template&id=c2d8e9c4&scoped=true&"
import script from "./english-test-question.vue?vue&type=script&lang=js&"
export * from "./english-test-question.vue?vue&type=script&lang=js&"
import style0 from "./english-test-question.vue?vue&type=style&index=0&id=c2d8e9c4&lang=scss&scoped=true&"
import style1 from "./english-test-question.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d8e9c4",
  null
  
)

export default component.exports